// extracted by mini-css-extract-plugin
module.exports = {"avatar":"UserButton_avatar__3fM6c","text":"UserButton_text__2e-vx","button":"UserButton_button__1AV16"};